const VOX_URL = process.env?.REACT_APP_VOX_URL ?? 'https://vox.poli.digital';

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage(data: string): void };
  }
}

interface VoxPhoneParams {
  contactID?: string | number;
  customerID?: string | number;
  userID?: string | number;
  contactName?: string;
  contactPicture?: string;
}

export function openVoxPhone(params: VoxPhoneParams): void {
  const query = new URLSearchParams();
  query.set('contactID', String(params.contactID ?? ''));
  query.set('customerID', String(params.customerID ?? ''));
  query.set('userID', String(params.userID ?? ''));
  query.set('contactName', params.contactName ?? '');
  if (params.contactPicture) {
    query.set('contactPicture', params.contactPicture);
  }

  const url = `${VOX_URL}?${query.toString().replace(/\+/g, '%20')}`;

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: 'OPEN_VOX', url })
    );
  } else {
    const popup = window.open(
      url,
      'popup',
      'width=700,height=500,noopener,noreferrer'
    );
    if (popup) popup.opener = null;
  }
}
